import Button from "./Button";
import Box from "@mui/material/Box";
import constants from "../constants";
import React, { useContext, useEffect } from "react";
import PinSvgIcon from "../Svg/PinSvgIcon";
import CloseSvgIcon from "../Svg/CloseSvgIcon";
import ApproveHooks from "../Hooks/ApproveHooks";
import AlertContext from "../context/AlertContext";
import CommentsHooks from "../Hooks/CommentsHooks";
import ImageLogoSvgIcon from "../Svg/ImageLogoSvgIcon";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";

export default function Approve() {
  const Alert = useContext(AlertContext);

  const {
    changeComments,
    handleCommentAttachment,
    handleDeleteCommentAttachment,
  } = CommentsHooks();

  const {
    addGrade,
    changeScore,
    scoreChanged,
    handleScoreSelect,
    tempScore,
    setTempScore,
  } = ApproveHooks();

  let actualscore =
    Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
      ? Alert.testDetail.data.sections[0].questions[
          Alert.testDetail.currentIndex
        ].actualscore
      : Alert.approveData.actualscore || 0;

  useEffect(() => {
    setTempScore(actualscore);
  }, [actualscore, setTempScore]);

  return (
    <div
      className="approveMainContainer"
      style={
        Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
          ? { right: "420px" }
          : {}
      }
    >
      <Box
        sx={{
          p: 3,
          width:
            Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
              ? 260
              : 360,
          boxShadow: 2,
          maxHeight: 600,
          borderRadius: 2,
          overflow: "auto",
          bgcolor: "#FFFFFF",
          minHeight:
            Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
              ? 190
              : Alert.showBreadCrumbsData.type ===
                constants.libTypeIds.ASSIGNMENT
              ? 458
              : 422,
        }}
      >
        <div className="approveLabel">
          {Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
            ? "Edit"
            : "Mark"}{" "}
          Score :
        </div>
        <div className="approveScoreDiv">
          <input
            onChange={changeScore}
            onClick={handleScoreSelect}
            className="approveScoreDivInput"
            value={tempScore}
            placeholder={actualscore}
          />

          <div className="approveScoreDivTotalMarks">
            /{" "}
            {Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
              ? Alert.testDetail.data.sections[0].questions[
                  Alert.testDetail.currentIndex
                ].targetscore
              : Alert.approveData.marks || Alert.testDetail.targetscore}
          </div>
        </div>
        {Alert.showBreadCrumbsData.type !== constants.libTypeIds.SQL && (
          <div className="approveInstructionDiv">
            <span className="approveInstructionDivLabel">
              You can evaluate by marking the score above
            </span>
          </div>
        )}

        {Alert.showBreadCrumbsData.type !== constants.libTypeIds.SQL && (
          <div className="approveCommentsLabel">Comments</div>
        )}
        {Alert.showBreadCrumbsData.type !== constants.libTypeIds.SQL && (
          <div>
            <TextareaAutosize
              key={"inputs" + 1}
              input={Alert.comment}
              value={Alert.comment}
              onChange={changeComments}
              className="approveCommentsTextArea"
              placeholder="Write your comment for the trainee"
            />
            {Alert.showBreadCrumbsData.type ===
              constants.libTypeIds.ASSIGNMENT &&
              Alert.commentAttachment.map((attachment) => (
                <div
                  key={attachment.id}
                  className="rejectCommentsForAssignmentFileUpload"
                >
                  <div className="rejectCommentsForAssignmentFileUploadInnerDiv">
                    <ImageLogoSvgIcon />
                    <div className="rejectCommentsForAssignmentFileUploadFileName">
                      {attachment.file.name}
                    </div>

                    <div className="rejectCommentsForAssignmentFileUploadFileSize">
                      {attachment.hasOwnProperty("file") &&
                      attachment.file.size !== undefined &&
                      (attachment.file.size / 1e6).toFixed(2) > 1
                        ? `${(attachment.file.size / 1e6).toFixed(2)} MB`
                        : `${(attachment.file.size / 1024).toFixed(2)} KB`}
                    </div>
                  </div>
                  <div className="rejectCommentsForAssignmentCloseSvgIcon">
                    <CloseSvgIcon
                      onClick={() =>
                        handleDeleteCommentAttachment(attachment.id)
                      }
                    />
                  </div>
                </div>
              ))}

            {Alert.showBreadCrumbsData.type ===
              constants.libTypeIds.ASSIGNMENT && (
              <div className="rejectCommentsForAssignmentAttachmentDiv">
                <PinSvgIcon />
                <input
                  multiple
                  type="file"
                  accept="image/*"
                  onChange={handleCommentAttachment}
                  className="rejectCommentsForAssignmentAttachmentInput"
                />
              </div>
            )}
          </div>
        )}

        <div className="approveButtonDiv">
          <Button
            size="sm"
            onClick={() => {
              setTempScore(actualscore);
              Alert.setScore(actualscore);
              Alert.setShowReject(false);
              Alert.setShowApprove(false);
            }}
            hierarchy={{
              buttonText: "Cancel",
              type: "secondaryGrey",
            }}
          />
          <Button
            size="sm"
            disabled={!scoreChanged && Alert.comment.length === ""}
            onClick={() => {
              addGrade(Alert.score);
            }}
            hierarchy={{
              type: "primary",
              buttonText:
                Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL
                  ? "Save"
                  : "Submit",
            }}
          />
        </div>
      </Box>
    </div>
  );
}
